export const DailyReportTostMessage = {
  SUCCESS: {
    CREATED: "Daily reports created successfully",
    UPDATED: "Daily reports updated successfully",
    DELETED: "Report deleted successfully",
    TABLE_UPDATED: "Daily report table updated successfully",
  },
};
export const EmptyDailyReportTableMessage = {
  SUBTITLE: "Add a new daily report to the list.",
  BTN_LABEL: "Add New Report",
};
